/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import NewContentList from './NewContentList'
// import moment from "moment";

import ContentItem6 from "../../components/event/ContentItem6";

import "../../css/event220617.css";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class Event202210_contentList extends Component {
  state = {
    //eventCode: 0,
    intReturn: -101,
    list: [],
  };
  componentDidMount = () => {
    // const eventCode = this.props.childProps.eventCode;
    //this._getContentList(eventCode)
  };

  _getContentList = async (eventCode) => {
    // const { loginId } = this.props;

    // const curDate = new Date();
    // const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    const result = await this._getContentListApi(eventCode);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    //console.log(contentList)

    if (intReturn === 0) {
      this.setState({
        intReturn,
        contentList,
      });
    }
  };

  _getContentListApi = (eventCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/event_202210_content", {
        params: {
          eventCode: eventCode,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  /*
    _expectApi = (keycode, contentSerial, grade) => {
        const { apiUrl, loginId } = this.props;
        
        return axios.post(apiUrl + '/event_202201_expect', {
            params: {
                keycode: keycode,
                contentSerial: contentSerial,
                grade: grade
            }
        })
    }
    */
  _renderItem = () => {
    const { keyCode } = this.state;
    const { _expect, reset, contentList } = this.props.childProps;
    const list = contentList.map((item, index) => {
      return (
        <ContentItem6
          key={index}
          contentSerial={item.contentSerial}
          img={item.img}
          comment={item.comment}
          title={item.title}
          alramFlag={item.alramFlag}
          keyCode={keyCode}
          _expect={_expect}
          grade={item.rank}
          reset={reset}
        />
      );
    });
    return list;
  };
  _renderNull = () => {
    const { eventCode } = this.props.childProps;
    let test = [];

    if (eventCode === 1) {
      test = [];
    } else if (eventCode === 2) {
      test = [];
    } else if (eventCode === 3) {
      test = [];
    } else if (eventCode === 4) {
      test = [];
    } else if (eventCode === 5) {
      test = [];
    }

    const list = test.map((item, index) => {
      return (
        <div className="item" key={index}>
          <div className="thumb none">
            <img
              src="/img/event/event220916/list_img.png"
              className="img_web"
            />
            <img
              src="/img/event/event220916/m_list_img.png"
              className="img_m"
            />
          </div>
          {/*<button type="button" className="btnAlram">뽑기선택1</button>*/}
        </div>
        /*
                <li key={index} style={{ width: 224, height: 502}}>
                    <div className="thumb"></div>
                   
                </li>
                */
      );
    });
    return list;
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  render() {
    //const {  intReturn } = this.state;
    const { contentList, intReturn } = this.props.childProps;

    // let title = "";

    // if (eventCode === 1) {
    //   title = "3/26";
    // } else if (eventCode === 2) {
    //   title = "3/27";
    // } else if (eventCode === 3) {
    //   title = "3/28";
    // } else if (eventCode === 4) {
    //   title = "3/29";
    // } else if (eventCode === 5) {
    //   title = "3/30";
    // }
    return (
      <Fragment>
        {intReturn === 0 ? (
          <ul className="list">
            <li>
              {contentList ? this._renderItem() : null}
              {contentList ? this._renderNull() : null}
            </li>
          </ul>
        ) : (
          <Fragment></Fragment>
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202210_contentList));
